const educatorsHeroSection = $('#hero-section');

const heroBGInAnimation = () => {
  const heroBG = educatorsHeroSection.find('.hero-section-bg');

  const heroBGTL = gsap.timeline({ paused: true });

  heroBGTL.add(
    gsap.to(heroBG, {
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      duration: 3.01,
      ease: 'opacityInEasing',
    })
  );

  return heroBGTL;
};

const addEducatorsHeroAnimation = () => {
  const animationConfig = {
    offsetPercent: '150',
    opacityStart: 0.9,
    blurStart: '5px',
    duration: 0.9,
    delay: 0,
    stagger: 0.15,
    isDurationCommon: false,
  }
  
  const heroDescription = educatorsHeroSection.find('.hero-description');
  const heroTitle = educatorsHeroSection.find('.hero-title');
  const heroDescriptorCard = educatorsHeroSection.find('.descriptor-card');
  const heroBtn = educatorsHeroSection.find('.button-parent');
  const scrollHandler = educatorsHeroSection.find('.scroll-handle');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });


  heroTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), '0.5');
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), '0.5');
  heroTL.add(elementInAnimationYWOpacity(scrollHandler, '200%', 0, 1, 0.667, 0.667, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), '0.95');
  //heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), '0.5');
  //heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), '0.95');
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), '0.9');
  heroTL.add(addBtnAnimation(heroBtn).play(), '1.5');
  heroTL.add(heroBGInAnimation().play(), '0');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), '2.13');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const educatorsHeroTL = addEducatorsHeroAnimation();
  pageIn(educatorsHeroTL, nav);
  if(window.location.href.includes('en-international')){
    toggleComingSoon(true);
  }
});
